import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { Howl } from "howler";
import { AudioManager } from "../AudioManager";
import { GameManager } from "../GameManager";
declare var GZLOADER: any

export class PreloadScene extends Phaser.Scene {

    public static currentInstance: PreloadScene;

    private progressBar: Phaser.GameObjects.Graphics;
    private scaledItemsContainer: Phaser.GameObjects.Container;

    constructor() {

        super("PreloadScene");

        PreloadScene.currentInstance = this;
    }

    public preload(): void {
        GZLOADER.modify(108, 200);

        this.loadAssets();
    }

    public create(): void {

        this.loadHowl();
    }

    private composeScene(): void {

        this.add.text(-100, -100, "abcdefg", { fontFamily: "Baloo", fontSize: "26px", color: "#FFFF00" });
        this.add.text(-100, -100, "abcdefg", { fontFamily: "Oswald-Semibold", fontSize: "26px", color: "#FFFF00" });

        const background = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "background");
        background.setScale(3);

        this.scaledItemsContainer = this.add.container(GameConstants.GAME_WIDTH / 2, 760);
        this.scaledItemsContainer.scaleY = GameVars.scaleY;

        const barWidth = 550;
        const barWHeight = 16;
        const borderWidth = 3;

        const preloadBarCapsuleBorder = new Phaser.GameObjects.Graphics(this);
        preloadBarCapsuleBorder.fillStyle(0x0386FF);
        preloadBarCapsuleBorder.fillRect(0, 0, barWidth + borderWidth * 2, barWHeight + borderWidth * 2);
        preloadBarCapsuleBorder.x = - barWidth / 2 - borderWidth;
        preloadBarCapsuleBorder.y = -borderWidth;
        this.scaledItemsContainer.add(preloadBarCapsuleBorder);

        const preloadBarCapsule = new Phaser.GameObjects.Graphics(this);
        preloadBarCapsule.fillStyle(0xFFFFFF);
        preloadBarCapsule.fillRect(0, 0, barWidth, barWHeight);
        preloadBarCapsule.x = - barWidth / 2;
        this.scaledItemsContainer.add(preloadBarCapsule);

        this.progressBar = new Phaser.GameObjects.Graphics(this);
        this.progressBar.fillStyle(0xB8EEFF);
        this.progressBar.fillRect(0, 0, barWidth, barWHeight);
        this.progressBar.x = - barWidth / 2;
        this.progressBar.scaleX = 0;
        this.scaledItemsContainer.add(this.progressBar);
    }

    private loadAssets(): void {

        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1.png", "assets/texture_atlas_1.json");
        this.load.atlas("texture_atlas_3", "assets/texture_atlas_3.png", "assets/texture_atlas_3.json");
        this.load.atlas("texture_atlas_4", "assets/texture_atlas_4.png", "assets/texture_atlas_4.json");
        this.load.atlas("texture_atlas_5", "assets/texture_atlas_5.png", "assets/texture_atlas_5.json");
        this.load.atlas("texture_atlas_6", "assets/texture_atlas_6.png", "assets/texture_atlas_6.json");
        this.load.atlas("texture_atlas_7", "assets/texture_atlas_7.png", "assets/texture_atlas_7.json");

        // bitmapfonts
        this.load.bitmapFont("baloo", "assets/fonts/baloo.png", "assets/fonts/baloo.xml");
        this.load.bitmapFont("baloo-cyan", "assets/fonts/baloo-cyan.png", "assets/fonts/baloo-cyan.xml");
        this.load.bitmapFont("baloo-red", "assets/fonts/baloo-red.png", "assets/fonts/baloo-red.xml");

        // EL TEXTO DEL JUEGO
        this.load.json("game-text", "assets/config/text.json");

        // audio
        this.load.json("audiosprite", "assets/audio/audiosprite.json");

        this.load.on("progress", this.updateLoadedPercentage, this);
    }

    private updateLoadedPercentage(percentageLoaded: number): void {
        GZLOADER.loadProcess(percentageLoaded * 100);
        // if (this.progressBar.scaleY < percentageLoaded) {
        //     this.progressBar.scaleY = percentageLoaded;
        // }
    }

    private loadHowl(): void {

        let audioSpriteJSON = this.cache.json.get("audiosprite");
        audioSpriteJSON = JSON.parse(JSON.stringify(audioSpriteJSON).replace("urls", "src"));
        audioSpriteJSON = JSON.parse(JSON.stringify(audioSpriteJSON).replace("../", ""));
        audioSpriteJSON = JSON.parse(JSON.stringify(audioSpriteJSON).replace("../", ""));

        AudioManager.howl = new Howl(audioSpriteJSON);

        AudioManager.howl.on("load", function (): void {
            GZLOADER.unload();
            GameManager.onGameAssetsLoaded();
        });
    }
}
